// Close the mobile menu when a link inside it is chosen, and on Escape.
document.addEventListener('click', (e) => {
  const link = e.target.closest('.menu-drawer a');
  if (link) link.closest('details')?.removeAttribute('open');
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') document.querySelectorAll('details[open].menu-drawer-wrap').forEach((d) => d.removeAttribute('open'));
});
// Auto-submit cart quantity changes.
document.addEventListener('change', (e) => {
  if (e.target.matches('[data-cart-qty]')) e.target.form.submit();
});
